import { DataDisplayList } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { ControlProps, UISchemaElement } from "@jsonforms/core";
import { JsonFormsDispatch, withJsonFormsControlProps } from "@jsonforms/react";

import { strToKebabCase, getKeyFromScope } from "../utils";

interface Dictionary<T> {
  [Key: string]: T;
}

function processOutput(
  element: any,
  result: Dictionary<object>,
  rowNum: number,
  componentProps: ControlProps
) {
  // if there are child elements/controls to dispatch, process those
  const children = element.options?.detail?.elements;

  if (children?.length > 0) {
    return (
      <span className={styles.dataDisplayListCell}>
        {children.map((elem: UISchemaElement, index: number) => {
          return (
            <JsonFormsDispatch
              key={index}
              schema={componentProps.schema}
              uischema={elem}
              path={`${componentProps.path}`}
            />
          );
        })}
      </span>
    );
  }

  // duplicate element so it can be manipulated
  const cloned_element = JSON.parse(JSON.stringify(element));

  // remove label - it's been handled already by the DataDisplayList
  delete cloned_element.label;

  if (element.type === "Control" || element.type === undefined) {
    cloned_element.type = "TextDisplay";
    cloned_element.options = {
      style: "global/body-primary",
      ...cloned_element.options,
    };
  }
  return (
    <span>
      <JsonFormsDispatch
        key={1}
        schema={componentProps.schema}
        uischema={cloned_element}
        path={`${componentProps.path}`}
      />
    </span>
  );
}

export function DataDisplayListControl(props: ControlProps) {
  if (!props.visible) {
    return null;
  }

  if (!props.data) {
    return null;
  }

  const options = props.uischema.options || {};
  const results = props.data;

  if (options?.detail.elements.length <= 0) {
    return null;
  }

  return (
    <DataDisplayList
      key={`${strToKebabCase(options.detail.elements[0].label)}`}
      aria-label={`${options.detail.elements[0].label} results`}
      testID={`${strToKebabCase(
        getKeyFromScope(props.uischema.scope)
      )}-data-display-list`}
      isColumn={options?.isColumn}
      data={options?.detail.elements.map(
        (element: Record<string, unknown>, index: number) => ({
          key: `row${index.toString()}`,
          label: element.label ? element.label.toString() : "",
          value: processOutput(element, results, index, props),
        })
      )}
    />
  );
}

const styles = {
  dataDisplayListCell: css({
    wordBreak: "break-word",
    fontSize: "var(--font-size-100)",
  }),
};

export const DataDisplayListRenderer = withJsonFormsControlProps(
  DataDisplayListControl
);
